module.exports = __webpack_public_path__ + "img/news-preview.e0b29d05.png";